import PVPFTServiceDetail from "./PVPFTServiceDetail";

export default PVPFTServiceDetail;
